import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Component({
    selector: 'new-blog',
    templateUrl: './new-blog.component.html',
    styleUrls: ['./new-blog.component.scss'],
    standalone: false
})
export class NewBlogComponent implements OnInit {
  @Input() info;

  videoUrl;

  constructor(private _sanitizer: DomSanitizer) {}

  ngOnInit() {
    if (this.info && this.info.video) {
      if (this.info.video.indexOf('embed') !== -1) {
        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.info.video
        );
      } else {
        this.videoUrl = this._sanitizer.bypassSecurityTrustResourceUrl(
          this.parseYoutube(this.info.video)
        );
      }
    } else {
      this.videoUrl = '';
    }
  }

  parseYoutube(url) {
    let link = 'https://www.youtube.com/embed/';
    const videoId = url.split('?v=');
    link = link + videoId[1];
    return link;
  }
}
